import { Tabs } from "antd";
import SalesByZone from "./SalesReportsTabs/SalesByZone";
import SalesByItem from "./SalesReportsTabs/SalesByItem";
import SalesByCustomer from "./SalesReportsTabs/SalesByCustomer";
import SalesByOrderType from "./SalesReportsTabs/SalesByOrderType";
import SalesByDeliveryMode from "./SalesReportsTabs/SalesByDeliveryMode";
import SalesByTimeSlot from "./SalesReportsTabs/SalesByTimeSlot";
import { useEffect, useState } from "react";
import { checkPermissionAction } from "../../../../utils/helper/utils";
import { useLocation } from "react-router-dom";
import SalesByVendor from "./SalesReportsTabs/SalesByVendor";
import SalesByDriver from "./SalesReportsTabs/SalesByDriver";
const x = {
  1: "Sales By Zone Report",
  2: "Sales By Item Report",
  3: "Sales By Customer Report",
  4: "Sales By Order Type Report",
  5: "Sales By Delivery Mode Report",
  6: "Sales By Time Slot Report",
  7: "Sales By Vendor Report",
  8: "Sales By Driver Report",
};

const SalesReports = ({ inputData, changeSubTabIndex, permissionJson, initialSubTabIndex }) => {
  const location = useLocation();
  const tabIndexProp = initialSubTabIndex || location.state?.tabIndex || "1";
  const [tabIndex, setTabIndex] = useState(tabIndexProp);

  useEffect(() => {
    if (!checkPermissionAction(x?.[tabIndex], permissionJson, "view")) {
      if (checkPermissionAction("Sales By Zone Report", permissionJson, "view")) setTabIndex("1");
      else if (checkPermissionAction("Sales By Item Report", permissionJson, "view")) setTabIndex("2");
      else if (checkPermissionAction("Sales By Customer Report", permissionJson, "view")) setTabIndex("3");
      else if (checkPermissionAction("Sales By Order Type Report", permissionJson, "view")) setTabIndex("4");
      else if (checkPermissionAction("Sales By Delivery Mode Report", permissionJson, "view")) setTabIndex("5");
      else if (checkPermissionAction("Sales By Time Slot Report", permissionJson, "view")) setTabIndex("6");
      else if (checkPermissionAction("Sales By Vendor Report", permissionJson, "view")) setTabIndex("7");
      else if (checkPermissionAction("Sales By Driver Report", permissionJson, "view")) setTabIndex("8");
    }
  }, [permissionJson, tabIndex]);

  //change tab index
  const changeTabIndex = (index) => {
    setTabIndex(index);
    changeSubTabIndex(index);
  };

  return (
    <>
      <Tabs activeKey={tabIndex} onChange={changeTabIndex}>
        {checkPermissionAction("Sales By Zone Report", permissionJson, "view") ? (
          <Tabs.TabPane tab={"Sales by zone"} key={1}>
            {tabIndex === "1" && <SalesByZone inputData={inputData} tabIndex={tabIndex} />}
          </Tabs.TabPane>
        ) : null}
        {checkPermissionAction("Sales By Item Report", permissionJson, "view") ? (
          <Tabs.TabPane tab={"Sales by Item"} key={2}>
            {tabIndex === "2" && <SalesByItem inputData={inputData} tabIndex={tabIndex} />}
          </Tabs.TabPane>
        ) : null}
        {checkPermissionAction("Sales By Customer Report", permissionJson, "view") ? (
          <Tabs.TabPane tab={"Sales by Customer"} key={3}>
            {tabIndex === "3" && <SalesByCustomer inputData={inputData} tabIndex={tabIndex} />}
          </Tabs.TabPane>
        ) : null}
        {checkPermissionAction("Sales By Order Type Report", permissionJson, "view") ? (
          <Tabs.TabPane tab={"Sales by Order Type"} key={4}>
            {tabIndex === "4" && <SalesByOrderType inputData={inputData} tabIndex={tabIndex} />}
          </Tabs.TabPane>
        ) : null}
        {checkPermissionAction("Sales By Delivery Mode Report", permissionJson, "view") ? (
          <Tabs.TabPane tab={"Sales by Delivery Mode"} key={5}>
            {tabIndex === "5" && <SalesByDeliveryMode inputData={inputData} tabIndex={tabIndex} />}
          </Tabs.TabPane>
        ) : null}
        {checkPermissionAction("Sales By Time Slot Report", permissionJson, "view") ? (
          <Tabs.TabPane tab={"Sales by Time Slot"} key={6}>
            {tabIndex === "6" && <SalesByTimeSlot inputData={inputData} tabIndex={tabIndex} />}
          </Tabs.TabPane>
        ) : null}
        {checkPermissionAction("Sales By Vendor Report", permissionJson, "view") ? (
          <Tabs.TabPane tab={"Sales by Vendor"} key={7}>
            {tabIndex === "7" && <SalesByVendor inputData={inputData} tabIndex={tabIndex} />}
          </Tabs.TabPane>
        ) : null}
        {checkPermissionAction("Sales By Driver Report", permissionJson, "view") ? (
          <Tabs.TabPane tab={"Sales by Driver"} key={8}>
            {tabIndex === "8" && <SalesByDriver inputData={inputData} tabIndex={tabIndex} />}
          </Tabs.TabPane>
        ) : null}
      </Tabs>
    </>
  );
};
export default SalesReports;
